import { useCallback, useState } from 'react';
import { useGlobalStore } from '../providers/GlobalStoreProvider.tsx';
import { ContractorVerificationStatuses } from '../constants/entities.ts';

export const useCompanyVerificationCheck = () => {
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);
  const { agency } = useGlobalStore();

  const isCompanyVerified = useCallback(() => {
    const verificationStatus = agency.data?.verificationStatus;
    return verificationStatus === ContractorVerificationStatuses.Verified;
  }, [agency.data?.verificationStatus]);

  const isCompanyVerificationRequired = useCallback(() => {
    const verificationStatus = agency.data?.verificationStatus;
    return (
      verificationStatus === ContractorVerificationStatuses.Pending ||
      verificationStatus === ContractorVerificationStatuses.NotVerified
    );
  }, [agency.data?.verificationStatus]);

  const checkVerificationAndProceed = useCallback((onSuccess: () => void) => {
    if (isCompanyVerificationRequired()) {
      setIsVerificationModalOpen(true);
      return false;
    }

    onSuccess();
    return true;
  }, [isCompanyVerificationRequired]);

  const closeVerificationModal = useCallback(() => {
    setIsVerificationModalOpen(false);
  }, []);

  return {
    isCompanyVerified,
    isCompanyVerificationRequired,
    checkVerificationAndProceed,
    isVerificationModalOpen,
    closeVerificationModal,
  };
};
